import { chainOptions } from "const";
import {
  abi as softAbi,
  bytecode,
} from "../../contracts/SoftStaking.sol/SoftStaking.json";
// import { abi as erc20Abi } from "../../contracts/ERC20Mock.json";
import { Contract, ContractFactory, ethers } from "ethers";

// const chainPrc = process.env.REACT_APP_CHAIN_PRC;

const getSoftPayeeAddress = async () => {
  if (!window.ethereum) return;
  const { ethereum } = window;
  const provider = new ethers.providers.Web3Provider(ethereum);
  const { chainId } = await provider.getNetwork();
  return chainOptions().find((c) => +c.value === +chainId)?.config
    ?.softPayeeAddress;
};

const getSoftSignerAddress = async () => {
  if (!window.ethereum) return;
  const { ethereum } = window;
  const provider = new ethers.providers.Web3Provider(ethereum);
  const { chainId } = await provider.getNetwork();
  return chainOptions().find((c) => +c.value === +chainId)?.config
    ?.softSignerAddress;
};

export async function deploySoft(signer, { coinAddress, collection }) {
  const factory = new ContractFactory(softAbi, bytecode, signer);

  // if (
  //   !(process.env.REACT_APP_SOFT_SIGNER_ADDRESS &&
  //     process.env.REACT_APP_SOFT_PAYEE_ADDRESS)) {
  //   throw new Error("Soft staking signer and payee addresses are not set");
  // }

  const softPayeeAddress = await getSoftPayeeAddress();
  const softSignerAddress = await getSoftSignerAddress();

  const contract = await factory.deploy(
    coinAddress,
    collection,
    // process.env.REACT_APP_SOFT_SIGNER_ADDRESS,
    // process.env.REACT_APP_SOFT_PAYEE_ADDRESS,
    softSignerAddress,
    softPayeeAddress
  );

  return {
    transaction: contract.deployTransaction,
    data: { address: contract.address },
  };
}

export function getSoftStakingContract(address, signer) {
  return new Contract(address, softAbi, signer);
}
